module.exports = __webpack_public_path__ + "static/startups_4-b1c9b6050ec8d635d20f8f102ccb51cd.png";